import { render, staticRenderFns } from "./panel_death.vue?vue&type=template&id=5768a952&scoped=true&"
import script from "./panel_death.vue?vue&type=script&lang=js&"
export * from "./panel_death.vue?vue&type=script&lang=js&"
import style0 from "./panel_death.vue?vue&type=style&index=0&id=5768a952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5768a952",
  null
  
)

export default component.exports